<template>
  <div class="animated fadeIn">
    <div v-show="hasProducts">
      <!-- Toggle Visualização Detalhada - MELHORIA 8.697 -->
      <div v-if="checkTypeBoard(card, 'COBRANCA') || checkTypeBoard(card, 'AJUIZAMENTO')" class="mb-3">
        <div style="display: flex; align-items: center; justify-content: space-between;">
          <span class="ml-1" style="font-size: 1.1em">
            <i class="fas fa-eye"></i> Visualização
          </span>
          <div style="display: flex; align-items: center; gap: 10px;">
            <span style="font-size: 0.95em; color: #6c757d; font-weight: 500;">
              {{ showParcelasDetalhadas ? 'Analítico' : 'Sintético' }}
            </span>
            <toogleswitch
              v-model="showParcelasDetalhadas"
              label=""
            />
          </div>
        </div>
      </div>

      <div v-if="checkTypeBoard(card, EnumBoardTypes.VENDA) || checkTypeBoard(card, EnumBoardTypes.OPERACAO)">
        <span
          class="ml-1"
          style="font-size: 1.1em"
          >Alterar Visualização
        </span>
        <toogleswitch
          style="margin-top: 10px; margin-bottom: 10px;"
          v-model="showNewPreview"
          label="Campanhas Ativas"
        />
      </div>
      <!-- Visualização Detalhada de Parcelas - MELHORIA 8.697 -->
      <ParcelasDetalhadas
        ref="parcelasDetalhadas"
        v-if="showParcelasDetalhadas && (checkTypeBoard(card, 'COBRANCA') || checkTypeBoard(card, 'AJUIZAMENTO'))"
        :card-produtos="objList"
        :card-id="card.id"
        :card="card"
        @promessa-criada="onPromessaCriada"
      />

      <!-- Visualização Consolidada (Atual) -->
      <Tables
        v-else-if="!showParcelasDetalhadas && (checkTypeBoard(card, 'COBRANCA') || checkTypeBoard(card, 'AJUIZAMENTO'))"
        ref="tableGrid"
        :columns="[
          $lang.Common.DataTable.ProductTable.Date,
          $lang.Common.DataTable.ProductTable.Product,
          $lang.Common.DataTable.ProductTable.Operation,
          $lang.Common.DataTable.ProductTable.DaysLate,
          $lang.Common.DataTable.ProductTable.Value,
          $lang.Common.DataTable.ProductTable.Risk,
          $lang.Common.DataTable.ProductTable.Observation,
          $lang.Common.DataTable.Actions
        ]"
        v-on:Load="onLoad"
        v-on:Reload="onReceiveReload"
      >
        <tr
          v-for="obj in this.objList"
          v-bind:key="obj.id"
        >
          <TableColumn
          :classCss="textColorProduct(obj)"
            :IsText="true"
            v-on:Edit="!isProductGanhoOrPerdido(obj) ? onEdit(obj) : null"
            :status="1"
            :value="formatDate(obj.data, true)"
          />
          <TableColumn
          :classCss="textColorProduct(obj)"
            :IsText="true"
            v-on:Edit="!isProductGanhoOrPerdido(obj) ? onEdit(obj) : null"
            :status="1"
            :value="obj.produtoDTO ? obj.produtoDTO.nome : ''"
          />
          <TableColumn
          :classCss="textColorProduct(obj)"
            :IsText="true"
            v-on:Edit="!isProductGanhoOrPerdido(obj) ? onEdit(obj) : null"
            :status="1"
            :value="obj.operacao"
          />
          <TableColumn
          :classCss="textColorProduct(obj)"
            :IsText="true"
            v-on:Edit="!isProductGanhoOrPerdido(obj) ? onEdit(obj) : null"
            :status="1"
            :value="obj.diasAtraso ? obj.diasAtraso.toString() : ''"
          />
          <TableColumn
          :classCss="textColorProduct(obj)"
            :IsText="true"
            v-on:Edit="!isProductGanhoOrPerdido(obj) ? onEdit(obj) : null"
            :status="1"
            :value="formatValue(obj.valor) != 'R$ 0,00'? formatValue(obj.valor) : '-'"
          />
          <!-- <TableColumn
          :classCss="textColorProduct(obj)"
            :IsText="true"
            v-on:Edit="!isProductGanhoOrPerdido(obj) ? onEdit(obj) : null"
            :status="1"
            :value="obj.quantidade ? obj.quantidade : '-'"
          /> -->
          <TableColumn
          :classCss="textColorProduct(obj)"
            :IsText="true"
            v-on:Edit="!isProductGanhoOrPerdido(obj) ? onEdit(obj) : null"
            :status="1"
            :value="obj.risco"
          />
          <TableColumn :IsCustom="true">
            <td
              class="text-center text-third"
              style="font-size: 16px; border: 0px; padding: 0px 0px 0px 35px"
              v-if="obj.observacao"
            >
              <span>
                <strong
                  v-b-tooltip.hover
                  :title="obj.observacao"
                >
                  <i class="fas fa-comment"></i>
                </strong>
              </span>
            </td>
          </TableColumn>
          <TableColumn
            :IsActionsButtons="true"
            :HasChange="false"
            v-on:Delete="deleteProduct(obj)"
            :status="obj.status"
          />
        </tr>
        <template slot="table-footer">
          <tr>
            <td
              colspan="3"
              class="text-right text-third"
            >
              <strong
                ><i class="fas fa-funnel-dollar text-third"></i>&nbsp;
                {{ formatValue(totalValue) }}</strong
              >
            </td>
            <td colspan="2">&nbsp;</td>
          </tr>
        </template>
      </Tables>

      <Tables
        ref="tableGrid"
        :columns="checkTypeBoard(card, EnumBoardTypes.VENDA) ? columnsVenda : columnsBase"
        v-on:Load="onLoad"
        v-on:Reload="onReceiveReload"
        v-else-if="!showNewPreview"
      >
        <tr
          v-for="obj in this.objList"
          v-bind:key="obj.id"
        >
          <TableColumn
            :classCss="textColorProduct(obj)"
            :IsText="true"
            v-on:Edit="!isProductGanhoOrPerdido(obj) ? onEdit(obj) : null"
            :status="1"
            :value="formatDate(obj.data, true)"
          />
          <TableColumn
            :classCss="textColorProduct(obj)"
            :IsText="true"
            v-on:Edit="!isProductGanhoOrPerdido(obj) ? onEdit(obj) : null"
            :status="1"
            :value="obj.produtoDTO ? obj.produtoDTO.nome : ''"
          />
          <TableColumn
            :classCss="textColorProduct(obj)"
            :IsText="true"
            v-on:Edit="!isProductGanhoOrPerdido(obj) ? onEdit(obj) : null"
            :status="1"
            :value="formatValue(obj.valor) != 'R$ 0,00' ? formatValue(obj.valor) : '-'"
          />
          <TableColumn
            v-if="checkTypeBoard(card, EnumBoardTypes.VENDA)"
            :classCss="textColorProduct(obj)"
            :IsText="true"
            v-on:Edit="!isProductGanhoOrPerdido(obj) ? onEdit(obj) : null"
            :status="1"
            :value=" valueInstallments(obj)"
          />
          <TableColumn
            v-if="checkTypeBoard(card, EnumBoardTypes.VENDA)"
            :classCss="textColorProduct(obj)"
            :IsText="true"
            v-on:Edit="!isProductGanhoOrPerdido(obj) ? onEdit(obj) : null"
            :status="1"
            :value="String(obj.quantidade ? obj.quantidade : '-')"
          />
          <TableColumn :IsCustom="true">
            <td
              :class="[
                textColorProduct(obj) !== ''
                  ? textColorProduct(obj)
                  : 'text-third'
              ]"
              style="font-size: 16px; border: 0px; padding: 0px 0px 0px 35px"
              v-if="obj.observacao"
            >
              <span
                ><strong
                  v-b-tooltip.hover
                  :title="obj.observacao"
                  ><i class="fas fa-comment"></i></strong
              ></span>
            </td>
          </TableColumn>
          <template v-if="checkTypeBoard(card, boardTypes.VENDA) && checkGainPerProduct(card) && !isProductGanhoOrPerdido(obj)">
            <td v-show="cardIsActive">
              <ActionButtonProduct
                :product="obj"
                @ActionProduct="actionProduct"
              />
            </td>
          </template>
          <template v-else>
            <TableColumn
              :IsActionsButtons="true"
              :HasChange="false"
              v-on:Delete="deleteProduct(obj)"
              :status="obj.status"
            />
          </template>
        </tr>
        <template v-if="formatValue(totalValue) != 'R$ 0,00'" slot="table-footer">
          <tr>
            <td
              colspan="3"
              class="text-right text-third"
            >
              <strong
                ><i class="fas fa-funnel-dollar text-third"></i>&nbsp;
                {{ formatValue(totalValue) }}</strong
              >
            </td>
            <td
              colspan="3"
              class="text-third text-center"
              v-if="checkTypeBoard(card, EnumBoardTypes.VENDA)"
            >
              <strong
                ><i class="fas fa-layer-group  text-third"></i>&nbsp;
                {{ totalUnit }}</strong
              >
            </td>
            <td colspan="2">&nbsp;</td>
          </tr>
        </template>
      </Tables>
    </div>
    <div v-if="showNewPreview">
      <b-tabs
              vertical
              ref="tableGrid"
              content-class="no-border"
              pills
              style="border: solid 1px #efefef; border-radius: 5px"
            >
              <div>
                <b-tab
                  v-for="(obj, index) in this.objList"
                  :key="obj.id"
                  :title="(index + 1).toString()"
                  :title-link-class="getProductTabClass(obj)"
                  class="no-border"
                >
                  <div
                    class="form-group row pr-3 pb-4"
                    :class="getProductCardBorderClass(obj)"
                    style="
                    float: right;
                    display: flex;
                    align-items: center;
                    gap: 12px;
                  "
                  >
                  <div
                      style="
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        width: 100%;
                      "
                    >
                      <span
                        v-if="!isProductGanhoOrPerdido(obj)"
                        class="pointer text-left"
                        @click="onEdit(obj)">
                        <i class="fa fa-pen" style="font-size: 1.2em"></i>
                      </span>

                      <TableColumn
                        :IsActionsButtons="true"
                        :HasChange="false"
                        v-on:Delete="deleteProduct(obj)"
                        :status="obj.status"
                      />
                      <template v-if="checkTypeBoard(card, boardTypes.VENDA) && checkGainPerProduct(card) && !isProductGanhoOrPerdido(obj)">
                      <td v-show="cardIsActive">
                        <ActionButtonProduct
                          :product="obj"
                          @ActionProduct="actionProduct"
                        />
                      </td>
                    </template>
                    </div>
                    <div class="col-md-12">
                      <label><strong>Data: &nbsp;</strong></label>
                      {{ formatDate(obj.data, true) }}
                    </div>
                    <div class="col-md-12">
                      <label><strong>Produto: &nbsp;</strong></label>
                      {{ obj.produtoDTO ? obj.produtoDTO.nome : '' }}
                    </div>
                    <div class="col-md-12 input-group">
                      <label>
                        <strong>Valor: &nbsp;</strong>
                         {{formatValue(obj.valor) != 'R$ 0,00' ? formatValue(obj.valor) : '-'}}
                      </label>
                    </div>
                    <div class="col-md-12 input-group">
                      <label>
                        <strong>Parcelas: &nbsp;</strong>
                          {{valueInstallments(obj)}}
                      </label>
                    </div>
                    <div class="col-md-12 input-group">
                      <label>
                        <strong>Unidade: &nbsp;</strong>
                        {{obj.quantidade ? obj.quantidade : '-'}}
                      </label>
                    </div>
                    <div class="col-md-12 input-group">
                      <label>
                        <strong>Observação: &nbsp;</strong>
                        {{ obj.observacao ? obj.observacao : '-' }}
                      </label>
                    </div>
                  </div>
                </b-tab>
              </div>
            </b-tabs>
    </div>
    <div v-show="!hasProducts && cardActive">
      Nenhum produto cadastrado,
      <strong
        @click="onAddProduct"
        style="cursor: pointer"
        >clique para adicionar</strong
      >
    </div>
    <ModalAddProduct
      v-if="cardActive"
      ref="ModalAddProduct"
      :card="card"
      v-on:Reload="onReceiveReload"
    />
  </div>
</template>

<script>
import CrmDetailsProduct from './product.js'
export default CrmDetailsProduct
</script>
<style lang="scss">
.nav.nav-pills {
  li.nav-item {
    margin-bottom: 0.2rem;
  }
}

// Estilo para produto GANHO (cor do botão GANHO: #00C851)
.nav-pills li.nav-item .nav-link.product-tab-ganho,
.nav-pills li.nav-item .nav-link.product-tab-ganho.active,
.nav-pills li.nav-item .nav-link.product-tab-ganho:hover {
  background-color: #00C851 !important;
  color: #ffffff !important;
  border: 2px solid #efefef !important;
}

// Estilo para produto PERDIDO (cor do botão PERDIDO: #FF4444)
.nav-pills li.nav-item .nav-link.product-tab-perdido,
.nav-pills li.nav-item .nav-link.product-tab-perdido.active,
.nav-pills li.nav-item .nav-link.product-tab-perdido:hover {
  background-color: #FF4444 !important;
  color: #ffffff !important;
  border: 2px solid #efefef !important;
}

// Borda do card de detalhes do produto - apenas neste componente
.product-card-ganho,
div.form-group.row.product-card-ganho,
div.form-group.row.pr-3.pb-4.product-card-ganho,
.tab-pane .product-card-ganho,
.tab-pane div.form-group.row.product-card-ganho,
.tab-pane div.form-group.row.pr-3.pb-4.product-card-ganho {
  border: 2px solid #00C851 !important;
  border-color: #00C851 !important;
  border-radius: 4px !important;
}

.product-card-perdido,
div.form-group.row.product-card-perdido,
div.form-group.row.pr-3.pb-4.product-card-perdido,
.tab-pane .product-card-perdido,
.tab-pane div.form-group.row.product-card-perdido,
.tab-pane div.form-group.row.pr-3.pb-4.product-card-perdido {
  border: 2px solid #FF4444 !important;
  border-color: #FF4444 !important;
  border-radius: 4px !important;
}
</style>
<style scoped>
.no-border {
  border: 0px;
}
</style>
<style>
.hover-link:hover {
  color: #04a791;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/views/private/crm/details/product/product.vue